import { Extended } from "@/framework/base/classes/Schema";
import Route from "@/generated/classes/Route";
import { scrollToSection } from "@/framework/notif/helpers/Notifs";
import { NotifWatcher } from "@/generated/router/RouteBuilder";
import { Fiches, Sections } from "@/generated/classes/AppSchema";
import { isMobile } from '@/style/StyleHelpers';
import Dialog from '@/generated/classes/Dialog';
import { openAlert } from "./SectionAlert.vue";
import { FieldStatus } from "./FieldInfo";
import { Alerts } from "../helpers/Alerts";
import { defineComponent, type PropType } from "vue";
import { useRoute, useRouter } from "vue-router";
import type {RouteElements} from "@/framework/base/classes/Section.ts";

export interface ScrollFiche {
  (): void;
}

export const staticExtended: Extended[] = [];
export let scrollFiche = undefined as ScrollFiche | undefined;

export function setScrollFiche (fct: ScrollFiche): void {
  scrollFiche = fct;
}

export default defineComponent({
  props: {
    parentType: {
      type: String
    },
    parentId: {
      type: Number
    },
    readOnly: {
      type: Boolean
    },
    attribut: {
      type: Object as PropType<unknown> | undefined
    },
    route: {
      type: Object as PropType<Route>,
    },
    routeElement: {
      type: Object as PropType<RouteElements>,
      required: false
    },
    showSection: {
      type: Boolean
    }
  },
  watch: {
    "showSection": [{
      handler: "onShowSectionChanged"
    }]
  },
  mounted (): void {
    this.isMounted = true;
    const nw: NotifWatcher = new NotifWatcher();
    nw.setWatcher(this.waitNotif);
    this.ficheMounted();
  },
  beforeUnmount (): void {
    this.closeDialog();
  },
  data () {
    const sections: string[] = [];
    const lastShowSection = undefined as boolean | undefined;
    const sectionData: any = '';
    const extendedSections: Extended[] = [];

    return {
      staticExtended,
      extendedSections,
      isMounted: false,
      dialogOpen: false,
      sectionName: '',
      sectionType: '',
      sectionTitle: '',
      sectionPicto: '',
      searchText: '',
      sectionData,
      isMobile: isMobile(),
      scrollFiche,
      fiche: Fiches.NONE,
      lastShowSection,
      sections,
      router: useRouter(),
      vueRoute: useRoute(),
      cardView: false
    };
  },
  computed: {
    section (): any {
      const sectionName = this.sectionName
      return this.$options.components?.[sectionName];
    },
    type (): string {
      return this.sectionType;
    },
    isCardView() : boolean {
      return this.cardView;
    }
  },

  methods: {
    addFiches (names: string[]): void {
      names.forEach(name => {
        let section = staticExtended.find(a => a.name == name && a.fiche == this.fiche);
        if (section == undefined) {
          section = new Extended(name, this.fiche, true);
          staticExtended.push(section);
        }
        this.extendedSections.push(section);
      })
    },
    isExtended (name: string): boolean {
      const section = staticExtended.find(a => a.name == name && a.fiche == this.fiche);
      return (section ? section.value : true);
    },
    setExtended (extended: Extended): void {
      let section = this.extendedSections.find(a => a.name == extended.name && a.fiche == this.fiche);
      if (section) {
        section.value = extended.value;
        section = staticExtended.find(a => a.name == extended.name && a.fiche == this.fiche);
        if (section) {
          section.value = extended.value;
        }
      }
    },
    updateStatus (): void {
      const status = new FieldStatus(false, false, 0);
      this.sections.forEach((section) => {
        if (this.isDisplayed(section)) {
          // @ts-expect-error : generated method
          if (!this.$refs[section] || !this.$refs[section].status) {
            Alerts.debug("Section :" + section + " Status missing");
          } else {
            // @ts-expect-error : generated method
            const sectionStatus = this.$refs[section].status;
            if (sectionStatus.error) {
              status.error = true;
            }
            if (sectionStatus.updated) {
              status.updated = true;
            }
            if (this.vueRoute.params && this.vueRoute.params.route) {
              // @ts-expect-error : generated method
              this.vueRoute.params.route.error = status.error;
              // @ts-expect-error : generated method
              this.vueRoute.params.route.updated = status.updated;
            }
          }
        }
      });
    },
    openAll (): void {
      this.extendedSections.forEach(s => {
        s.value = true;
        const section = staticExtended.find(st => st.name == s.name && st.fiche == this.fiche)
        if (section) {
          section.value = true;
        }
      });
    },
    closeAll (): void {
      this.extendedSections.forEach(s => {
        s.value = false;
        const section = staticExtended.find(st => st.name == s.name && st.fiche == this.fiche)
        if (section) {
          section.value = false;
        }
      });
    },
    closeFiche () {
      this.router.go(-1);
    },
    waitNotif (route: Route, dialog: Dialog): void {
      openAlert(dialog).then(() => {
        if (route.section != Sections.NONE) {
          scrollToSection(route.section);
        }
      });
    },
    isDisplayed (value: string): boolean {
      return true;
    },
    ficheMounted (): void {
      // To ovveride
    },
    setFullscreen (name: string, type: string, picto: string, data: any, title: string) {
      this.sectionName = name;
      this.sectionType = type;
      this.sectionPicto = picto;
      this.sectionData = data;
      this.sectionTitle = title;
      this.dialogOpen = true;
    },
    closeDialog () {
      this.dialogOpen = false;
      this.$emit('closeDialog');
    },
    selectItem (item: unknown): void {
      this.$emit("selectItem", item)
    },
    back (): void {
      this.$emit("back")
    },
    onShowSectionChanged () {
      if (this.showSection != this.lastShowSection && this.route && this.route.section && this.route.section != Sections.NONE) {
        const section = staticExtended.find(a => a.name == this.route.section && a.fiche == this.fiche);
        if (section && !section.value) {
          section.value = true;
        }
        scrollToSection(this.route.section);
        this.lastShowSection = this.showSection;
      }
    },
    toggleCardView (isCardView: boolean): void {
      this.cardView = isCardView;
    },
  }
})
